import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.outstanding_view.topupApprovedTitle',
        defaultMessage: "You're approved!"
    },
    interestOnlyTitle: {
        id: '_.outstanding_view.topupApprovedInterestOnlyTitle',
        defaultMessage: 'Your loan extension is approved!'
    },
    description: {
        id: '_.outstanding_view.topupApprovedDescription',
        defaultMessage:
            'You can drawdown up to {amount} at a rate of {interestRate} before {expiryDate}'
    },
    preApprovedDescription: {
        id: '_.outstanding_view.topupApprovedPreApprovedDescription',
        defaultMessage: 'You can drawdown up to {amount} before {expiryDate}'
    },
    interestOnlyDescription: {
        id: '_.outstanding_view.topupApprovedInterestOnlyDescription',
        defaultMessage:
            'You can extend your grace period by 3 months until {expiryDate}'
    },
    ctaText: {
        id: '_.outstanding_view.topupApprovedChooseAmountCTA',
        defaultMessage: 'Choose how much'
    },
    ctaTextInterestOnly: {
        id: '_.outstanding_view.topupApprovedInterestOnlyCTA',
        defaultMessage: 'Continue'
    },
    accessfundsCTAText: {
        id: '_.outstanding_view.accessfundsCTAText',
        defaultMessage: 'Access funds'
    }
});
